import React from "react";

interface ModalPaddingProps {
  className?: string;
  children: React.ReactNode;
  form?: boolean;
  [x: string]: any;
}
export const ModalPadding = ({ children, form = false, className = "", ...rest }: ModalPaddingProps) => {
  const compClassName = `px-5 pt-4 pb-6 ${className}`;

  return form ? (
    <form className={compClassName} {...rest}>
      {children}
    </form>
  ) : (
    <div className={compClassName}>{children}</div>
  );
};
